import {
    Component,
    ElementRef,
    HostListener,
    inject,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../service/layout.service';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { AppModule } from '../../app.module';
import { UserRoleEnum } from '../../user-info';
import { IUserRole } from '../../user-role';
import {
    catchError,
    filter,
    take,
    takeWhile,
    withLatestFrom
} from 'rxjs/operators';
import { PinDialogComponent } from '../../auth';
import { Observable, of, ReplaySubject, throwError } from 'rxjs';
import {
    ErrorsSidenavComponent,
    getErrorAction
} from '../../shared/errors-sidenav';
import { CompanyAccessDialogComponent } from '../../auth/company-access-dialog/company-access-dialog.component';
import { select, Store } from '@ngrx/store';
import {
    AutoCompleteModule,
    DialogModule,
    DialogService,
    EfaactPrimeNGModule,
    Process
} from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { AppComponent } from '../../app.component';
import * as fromAuth from '../../auth';
import * as fromDataServices from '../../data-services';
import * as fromUser from '../../user-info';
import { environment } from '../../../environments/environment';
import * as fromRoot from '../../store';
import { FormsModule } from '@angular/forms';
import { ErrorsSidenavWrapperComponent } from './ef-errors-sidenav-wrapper';
import { UIRouterModule } from '@uirouter/angular';
import { AppMenuProfile } from './app.menuprofile';
import * as fromShared from '../../shared';
import { PopoverModule } from 'primeng/popover';
@Component({
    selector: 'app-topbar-new',
    templateUrl: './app.topbar.html',
    styleUrls: ['./app.topbar.scss'],
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        DialogModule,
        AutoCompleteModule,
        FormsModule,
        StyleClassModule,
        InputTextModule,
        ButtonModule,
        IconFieldModule,
        InputIconModule,
        RippleModule,
        ErrorsSidenavWrapperComponent,
        UIRouterModule,
        AppMenuProfile,
        PopoverModule
    ]
})
export class AppTopbar implements OnInit, OnDestroy {
    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

    @ViewChild('searchInput') searchInput!: AutoComplete;

    constructor(
        public el: ElementRef,
        public app: AppComponent,
        private store: Store<fromUser.State>,
        public entityServices: EntityServices,
        private log: LoggingService,
        private dialogService: DialogService
    ) {
        this.companyAccessDataService =
            entityServices.getEntityCollectionService<fromDataServices.CompanyAccess.CompanyAccessModel>(
                fromDataServices.CompanyAccess.entityName
            );
        this.companyAccessDataService.clearCache();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event): void {
        const target = event.target as Element;

        // Check if click is within a dropdown or its trigger
        const isInErrorsDropdown = target.closest('#efErrorsSideNav');
        const isInHelpDropdown = target.closest('li:has(.help)') || target.closest('.help');
        const isInProfileDropdown = target.closest('li:has(.profile)') || target.closest('.profile');

        const clickedInside = this.el.nativeElement.contains(event.target);

        // Close dropdowns if clicking outside
        if (!isInErrorsDropdown && !isInHelpDropdown && !isInProfileDropdown) {
            this.closeAllDropdowns();
        }

        // Close sidenav if clicking outside topbar entirely
        if (!clickedInside) {
            this.closeSidenav();
        }
    }

    closeSidenav(): void {
        this.app.isSidenavOpen = false;
    }

    activeItem!: number;

    layoutService: LayoutService = inject(LayoutService);

    get mobileTopbarActive(): boolean {
        return this.layoutService.layoutState().topbarMenuActive;
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    onConfigSidebarToggle() {
        this.layoutService.showConfigSidebar();
    }

    toggleTheme(): void {
        this.layoutService.updateDarkTheme(!this.layoutService.isDarkTheme());
    }

    private componentActive = true;
    // public mainProcess$: Observable<Process[]>;
    auth$: Observable<fromAuth.State>;
    private switchCompanySubject = new ReplaySubject<string>(1);
    @Input() userInfo: fromUser.IUserInfo;
    @Input() user: fromUser.IUserAccess;
    @Input() roles: IUserRole[];
    private companyAccessDataService: EntityCollectionService<fromDataServices.CompanyAccess.CompanyAccessModel>;
    @Input() processes: Process[];
    @Input() processTitles: string[];
    public process$: Observable<Process>;

    showAbout = false;
    public environment = environment;
    public version$: Observable<string>;
    eFAACTApiVersion: string;
    eFAACTVersion = `${environment.version}-${environment.environment}`;
    softwareLicenseAgreementLink =
        'https://www.efaactcentral.com/licensing/eFAACTHostedLicenseAgreement.htm';

    selectedProcess: Process;
    currentProcess: Process;
    showProcessInfo = false;

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: Event): void {
        this.store.dispatch(fromShared.clearProcess());
    }

    @HostListener('window:unload', ['$event'])
    onUnload(event: Event): void {
        this.store.dispatch(fromShared.clearProcess());
    }

    openVideoLink(url: string): void {
        const fullUrl = url.startsWith('http') ? url : 'https://' + url;
        window.open(fullUrl, '_blank');
    }

    ngOnDestroy() {
        this.componentActive = false;
        this.store.dispatch(fromShared.clearProcess());
    }
    ngOnInit() {
        // this.mainProcess$ = this.store.pipe(
        //     select(fromUser.getUserProcessesMain),
        //     map(processes => processes.filter(p => p.displayinmenu))
        // );

        this.auth$ = this.store.pipe(select(fromAuth.getAuth));
        this.setupSubscriptions();

        // Debug: Log initial state
        this.log.verbose('AppTopbar ngOnInit', {
            processes: this.processes,
            processesLength: this.processes ? this.processes.length : 0,
            processTitles: this.processTitles
        });

        // For debugging - add some test data if no processes exist
        if (!this.processes || this.processes.length === 0) {
            this.log.verbose('No processes found, adding test data');
            this.processTitles = ['Test Process 1', 'Test Process 2', 'Test Dashboard'];
        }
    }
    setupSubscriptions() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        // Subscribe to process changes from the store
        this.process$
            .pipe(takeWhile(() => this.componentActive))
            .subscribe(process => {
                this.log.verbose({
                    type: 'AppTopBarComponent:processChanged',
                    process
                });

                if (process) {
                    this.currentProcess = process;
                } else {
                    this.currentProcess = null;
                }
            });

        setTimeout(() => {
            this.version$ = this.store.pipe(
                select(fromRoot.Version.selectVersion)
            );
            this.version$.pipe(take(2)).subscribe(v => {
                this.eFAACTApiVersion = v;
            });
        }, 1000);
        this.companyAccessDataService.entities$
            .pipe(
                takeWhile(() => this.componentActive),
                filter(x => !!x && x.length > 0),
                withLatestFrom(this.auth$)
            )
            .subscribe(([companyAccess, auth]) => {
                this.log.verbose({
                    type: 'AppTopBarComponent:companyAccessDataService:entities$',
                    companyAccess
                });
                this.dialogService
                    .open(CompanyAccessDialogComponent, {
                        header: 'Select Company Access',
                        closable: false,
                        closeOnEscape: false,
                        showHeader: false,
                        modal: true,
                        data: {
                            userInfo: this.userInfo,
                            companies: companyAccess
                        }
                    })
                    .onClose.pipe(take(1))
                    .subscribe(data => {
                        this.log.verbose({
                            type: 'AppTopBarComponent:CompanyAccessDialogComponent:afterClosed',
                            data
                        });
                        const company = companyAccess.find(
                            x => x.id === data.company
                        );
                        this.log.verbose({
                            type: 'AppTopBarComponent:CompanyAccessDialogComponent:afterClosed',
                            company
                        });
                        this.companyAccessDataService.clearCache();
                        this.companyAccessDataService
                            .getWithQuery({
                                CustomerID: company.CustomerID.toString(),
                                contactemail: company.contactemail
                            })
                            .pipe(
                                take(1),
                                catchError(err => {
                                    this.log.error(err);
                                    throwError(err);
                                    return of(getErrorAction(err));
                                })
                            )
                            .subscribe(q => {
                                this.log.verbose({
                                    type: 'AppTopBarComponent:companyAccessDataService:getWithQuery',
                                    q
                                });
                                this.store.dispatch(
                                    new fromAuth.RememberMe({
                                        rememberMe: auth.rememberMe,
                                        username: null,
                                        pin: company.CustomerID.toString()
                                    })
                                );
                                this.store.dispatch(new fromAuth.Logout());
                            });
                    });
            });
        this.switchCompanySubject
            .pipe(
                takeWhile(() => this.componentActive),
                withLatestFrom(this.auth$)
            )
            .subscribe(([, auth]) => {
                this.log.verbose({
                    type: 'AppTopBarComponent:switchCompanySubject'
                });
                this.dialogService
                    .open(PinDialogComponent, {
                        header: 'Enter main customer ID/PIN',
                        closable: false,
                        closeOnEscape: false,
                        showHeader: false,
                        modal: true,
                        data: {
                            userInfo: this.userInfo
                            // pin: auth.pin
                        }
                    })
                    .onClose.pipe(take(1))
                    .subscribe(data => {
                        this.log.verbose({
                            type: 'AppTopBarComponent:switchCompanySubject:afterClosed',
                            data
                        });
                        if (!!data && !!data.pin) {
                            this.companyAccessDataService.getWithQuery({
                                CustomerID: data.pin
                            });
                        }
                    });
            });
    }
    openAbout() {
        this.showAbout = true;
    }
    openHelpDesk() {
        if (this.user) {
            if (
                this.user.UserProcessesMain &&
                this.user.UserProcessesMain.length > 0
            ) {
                const helpdeskProcess = this.user.UserProcessesMain.find(
                    x => x.ProcessID == 134
                );
                const helpdeskLink = helpdeskProcess.UrlDemo;
                window.open(helpdeskLink, '_blank');
            }
        }
    }
    openUserManual() {
        window.open(
            'https://www.efaactcentral.com/eFAACTUserManual/index.htm?',
            '_blank'
        );
    }
    openCompanyCalendar() {}
    roleChosen(roleID: number) {
        this.store.dispatch(
            new fromUser.SetUserInfo({
                ...this.userInfo,
                DefaultRoleGroupID: roleID
            })
        );
    }
    switchCompany() {
        this.log.verbose({ type: 'AppTopBarComponent:switchCompany' });
        this.switchCompanySubject.next();
    }
    isAdmin = (roles: IUserRole[]): boolean =>
        roles &&
        !!roles.find(x => x.RoleGroupID === UserRoleEnum.Administrator);

    filterProcessFromSearch($event) {
        this.processTitles = [];

        this.log.verbose('Search event triggered', {
            query: $event.query,
            processes: this.processes,
            processesLength: this.processes ? this.processes.length : 0
        });

        this.hasSearchValue = !!($event.query && $event.query.length > 0);

        if (!$event.query) {
            this.log.verbose('No query provided');
            return;
        }

        if (this.processes && this.processes.length > 0) {
            // Create sets to track which processes are in which category types
            const processesInBizCategories = new Set<number>();
            const processesInNonBizCategories = new Set<number>();

            if (this.user && this.user.UserProcessCategories) {
                this.user.UserProcessCategories.forEach(category => {
                    category.UserProcesses.forEach(process => {
                        if (category.IsBizProcess) {
                            processesInBizCategories.add(process.ProcessID);
                        } else {
                            processesInNonBizCategories.add(process.ProcessID);
                        }
                    });
                });
            }

            // Use a Set to track unique process titles (to avoid duplicates)
            const uniqueProcessTitles = new Set<string>();

            const filteredProcesses = this.processes.filter(process => {
                // Include processes that appear in at least one non-business process category
                // (even if they also appear in business process categories)
                const isInNonBizCategory = processesInNonBizCategories.has(process.ProcessID);

                // Apply search filter
                const matchesSearch = process.ProcessTitle.toLowerCase().includes(
                    $event.query.toLowerCase()
                ) ||
                process.ProcessName.toLowerCase().includes(
                    $event.query.toLowerCase()
                ) ||
                process.RouteName.toLowerCase().includes(
                    $event.query.toLowerCase()
                );

                return isInNonBizCategory && matchesSearch;
            });

            filteredProcesses.forEach(x => {
                uniqueProcessTitles.add(x.ProcessTitle);
            });

            // Convert Set back to array for processTitles
            this.processTitles = Array.from(uniqueProcessTitles);
        } else {
            const testProcesses = ['Dashboard', 'User Management', 'Reports', 'Settings', 'Help Center'];
            const filtered = testProcesses.filter(title =>
                title.toLowerCase().includes($event.query.toLowerCase())
            );
            this.processTitles = filtered;
        }

        this.log.verbose('Search results', {
            query: $event.query,
            foundProcesses: this.processTitles.length,
            processTitles: this.processTitles
        });
    }

    gotoProcessFromSearch(event) {
        let selectedTitle: string;

        // Handle both string and object selections
        if (typeof event === 'string') {
            selectedTitle = event;
        } else if (event && event.value) {
            selectedTitle = event.value;
        } else {
            selectedTitle = event;
        }

        this.log.verbose('selected process from search: ' + selectedTitle);

        if (selectedTitle && this.processes) {
            const process = this.processes.find(x => x.ProcessTitle === selectedTitle);
            if (process) {
                this.app.goto(process);
            }
        }
    }

    onSearchClear() {
        this.selectedProcess = null;
        this.processTitles = [];
        this.isSearchFocused = false;
        this.hasSearchValue = false;
        this.log.verbose('search cleared');
    }

    // Search focus and icon management
    isSearchFocused = false;
    hasSearchValue = false;

    onSearchFocus() {
        this.isSearchFocused = true;
        this.log.verbose('search focused');
    }

    onSearchBlur() {
        this.isSearchFocused = false;
        this.hasSearchValue = !!(this.selectedProcess);
        this.log.verbose('search blurred', { hasValue: this.hasSearchValue });
    }

    focusSearch() {
        if (this.searchInput && this.searchInput.inputEL) {
            this.searchInput.inputEL.nativeElement.focus();
        }
    }

    // Dropdown state management
    private openDropdowns = new Set<string>();

    toggleDropdown(dropdownName: string): void {
        if (this.openDropdowns.has(dropdownName)) {
            this.openDropdowns.delete(dropdownName);
        } else {
            // Close all other dropdowns first
            this.openDropdowns.clear();
            this.openDropdowns.add(dropdownName);
        }
    }

    isDropdownOpen(dropdownName: string): boolean {
        return this.openDropdowns.has(dropdownName);
    }

    closeAllDropdowns(): void {
        this.openDropdowns.clear();
    }
}
